import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  className?: string;
  size?: 'md' | 'lg';
}
export function CTAButton({
  children,
  href = 'https://elevaemily.com/products/controla-la-ansiedad-1?variant=53010420498795',
  onClick,
  className = '',
  size = 'lg'
}: CTAButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center font-medium rounded-full text-white bg-terracotta hover:bg-terracotta-dark transition-colors shadow-lg shadow-terracotta/20 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-terracotta focus:ring-offset-cream';
  const sizeClasses = size === 'lg' ? 'px-8 py-4 text-lg' : 'px-6 py-3 text-base';
  const Element = motion.a;
  return <Element href={href} onClick={onClick} className={`${baseClasses} ${sizeClasses} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3
  }} data-id="element-27">
      {children}
    </Element>;
}